import * as React from 'react';
import styled from 'styled-components';
import { IconStyle } from '../Icon.styles.js';
const _IconCommunicationCustomerservice = (props) => {
    const { 'data-test-id': dataTestId, className, size, style, ...rest } = props;
    return (React.createElement("span", { "data-test-id": dataTestId, className: className, style: style }, size === '24'
        ? React.cloneElement(React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M12 3a8.003 8.003 0 0 0-7.752 6.016A2 2 0 0 0 2.5 11v3a2 2 0 0 0 2 2h.57a8.023 8.023 0 0 0 4.435 3.604 1 1 0 0 0 .995.896h3a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-.891.546 6.519 6.519 0 0 1-2.777-2.102A1 1 0 0 0 7.5 15v-5a1 1 0 0 0-1-1h-.687a6.503 6.503 0 0 1 12.373 0H17.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a2 2 0 0 0 2-2v-3a2 2 0 0 0-1.748-1.984A8.003 8.003 0 0 0 12 3Zm-6 7.5H4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H6v-4Zm12 4h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H18v4Z", fill: "currentColor" })), { width: 24, height: 24, ...rest })
        : null));
};
const defaultProps = {
    size: '24',
};
export const IconCommunicationCustomerservice = styled(_IconCommunicationCustomerservice) `
    ${IconStyle}
`;
IconCommunicationCustomerservice.defaultProps = defaultProps;
//# sourceMappingURL=IconCommunicationCustomerservice.js.map